import { useEffect, useState } from "react";
import { masterApi } from "@/contexts/MasterAuthContext";
import { History, RefreshCw } from "lucide-react";

const ACTION_LABEL = {
    'club.create': 'Kulüp Oluştur',
    'club.update': 'Kulüp Güncelle',
    'club.suspend': 'Kulüp Deaktif',
    'credit.adjust': 'Kredi Ayarla',
    'plan.change': 'Paket Değiştir',
    'domain.add': 'Domain Ekle',
};
const ACTION_COLOR = {
    'club.create': 'bg-emerald-500/10 text-emerald-400',
    'club.update': 'bg-blue-500/10 text-blue-400',
    'club.suspend': 'bg-red-500/10 text-red-400',
    'credit.adjust': 'bg-yellow-500/10 text-yellow-400',
};

export default function MasterAuditLog() {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = () => {
        setLoading(true);
        masterApi.get("/master/audit-log?limit=200").then((r) => setRows(r.data)).finally(() => setLoading(false));
    };
    useEffect(() => { load(); }, []);

    return (
        <div data-testid="master-audit-log">
            <div className="flex items-center justify-between mb-8">
                <div>
                    <div className="text-xs font-bold uppercase tracking-widest text-yellow-400 mb-2 flex items-center gap-2"><History size={14}/> Audit Log</div>
                    <h1 className="text-4xl font-extrabold tracking-tight">Aksiyon Geçmişi</h1>
                    <p className="text-neutral-400 mt-2">Master admin tarafından yapılan tüm değişiklikler</p>
                </div>
                <button onClick={load} data-testid="refresh-audit" className="inline-flex items-center gap-2 px-4 py-2 bg-[#1a1a1a] hover:bg-[#222] border border-[#2a2a2a] text-sm rounded-lg">
                    <RefreshCw size={14}/> Yenile
                </button>
            </div>

            {loading && <div>Yükleniyor…</div>}
            {!loading && rows.length === 0 && <div className="text-neutral-500 text-sm bg-[#121212] border border-[#2a2a2a] rounded-2xl p-8 text-center">Henüz audit kaydı yok</div>}

            <div className="bg-[#121212] border border-[#2a2a2a] rounded-2xl overflow-hidden">
                {rows.map((r) => (
                    <div key={r.id} data-testid={`audit-row-${r.id}`} className="px-5 py-4 border-b border-[#1f1f1f] last:border-0 flex items-start gap-4 hover:bg-[#1a1a1a] transition-colors">
                        <span className={`text-xs px-2 py-1 rounded font-semibold whitespace-nowrap ${ACTION_COLOR[r.action] || 'bg-neutral-500/10 text-neutral-400'}`}>
                            {ACTION_LABEL[r.action] || r.action}
                        </span>
                        <div className="flex-1 min-w-0">
                            <div className="text-sm">
                                {r.target_club_id ? <span className="text-yellow-400 font-mono">{r.target_club_id}</span> : <span className="text-neutral-500">—</span>}
                                {r.details && Object.keys(r.details).length > 0 && (
                                    <span className="text-neutral-400 ml-3">
                                        {Object.entries(r.details).slice(0, 3).map(([k, v]) => `${k}=${typeof v === 'object' ? JSON.stringify(v) : v}`).join(" · ")}
                                    </span>
                                )}
                            </div>
                            <div className="text-xs text-neutral-500 mt-1">
                                {r.master_admin_email} · {new Date(r.created_at).toLocaleString("tr-TR")}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
